import { render, staticRenderFns } from "./ViewBulkPaymentDetails.vue?vue&type=template&id=1fa9bcc2&"
import script from "./ViewBulkPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./ViewBulkPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports